// Dashboard.tsx
import { Box, Grid, Paper, Typography } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const Stats = () => {
  const cards = [
    {
      title: "Total Users",
      value: "42,830",
      change: "3.6%",
      changeType: "up",
      tooltip: "The number of daily users",
    },
    {
      title: "All Appointments",
      value: "96.4%",
      change: null,
    },
    {
      title: "Avg. Click Rate",
      value: "86.8%",
      change: "2.8%",
      changeType: "down",
    },
    {
      title: "Pageviews",
      value: "87,193",
      change: null,
    },
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={3}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper elevation={3} sx={{ p: 2 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ textTransform: "uppercase" }}
              >
                {card.title}
              </Typography>

              <Box
                sx={{ mt: 1, display: "flex", alignItems: "center", gap: 1 }}
              >
                <Typography variant="h5" sx={{ fontWeight: 500 }}>
                  {card.value}
                </Typography>
                {card.change && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color:
                        card.changeType === "up"
                          ? "success.main"
                          : "error.main",
                    }}
                  >
                    {card.changeType === "up" ? (
                      <ArrowUpwardIcon fontSize="small" />
                    ) : (
                      <ArrowDownwardIcon fontSize="small" />
                    )}
                    <Typography variant="body2">{card.change}</Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Stats;
